// extracted by mini-css-extract-plugin
export default {"main":"c5e34f2f70 _3a3d335f65","xmark":"f3cf7db57e","fl_img":"_370ba210d5 _0f0effdf52"};